import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { ITCYStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'

export async function getTCYStakingAPRConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_tcy_stats', timeframe)) as ITCYStats[]
	const series1 = chartData.map((element: ITCYStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TCY_STAKING_APR_PCT }
	})
	const config: IChart[] = [
		{
			data: series1,
			strokeWidth: 2,
			name: 'tcy APR',
			type: 'line',
			seriesGroup: '[%]',
			color: 'green',
			unitSymbol: '%'
		}
	]
	return { config: config, latestValue: series1[series1.length - 1].y, latestValueDate: series1[series1.length - 1].x }
}

const TCYStakingAPR = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTCYStakingAPRConfig)

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="TCY Staking APR"
			chartDesc="Current annual percentage rate for TCY staking. For each day average total staking balance and average yield from last 7 days is calculated, divided and multiplied by 365 to extrapolate yearly earning percentage."
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="7a055efe-72db-4ee0-b542-d4fa0541c84d"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
		/>
	)
}

export default TCYStakingAPR
